import React from "react";
import { getId } from "~assets/frontend/_util/getId";
export function FormGroup(props) {
    const uuid = getId();
    return (React.createElement("div", { className: "relative mb-24 w-full", onFocus: props.onFocus, onBlur: props.onBlur },
        React.createElement("label", { id: uuid + "_label", htmlFor: props.htmlFor, className: props.hideLabel ? "absolute left-[1000px] top-[-1000px]" : "mb-12" }, props.label),
        React.createElement("div", { "aria-describedby": props.helpText ? uuid + "_help" : uuid + "_label" }, props.children),
        props.helpText && (React.createElement("p", { id: uuid + "_help", className: "small help-text mt-12" }, props.helpText))));
}
